export function emailFormatter(email?: string) {
    if (!email) return "";
    return email.substring(0, 1) + "**" + email.substring(email.indexOf("@"));
}

export function capitaliseFirstLetter(string?: string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
}
